import React from 'react';

/**
 * 文章摘要显示组件
 * 
 * 功能：
 * 1. 直接使用数据库返回的AI摘要
 * 2. 如果AI摘要为空，显示"暂无文章摘要"
 * 3. 内容超出长度时显示省略号
 */
const PostSummary = ({ 
  aiSummary, 
  maxLength = 100,
  className = ''
}) => {
  if (!aiSummary || aiSummary.trim() === '') {
    return (
      <p className={`post-summary ${className} empty`}>
        <span className="summary-placeholder">暂无文章摘要</span>
      </p>
    );
  }

  const displaySummary = aiSummary.length > maxLength 
    ? aiSummary.substring(0, maxLength) + '...' 
    : aiSummary;

  return (
    <p className={`post-summary ${className} ai-generated`} title={aiSummary}>
      {displaySummary}
    </p>
  );
};

export default PostSummary;
